import { NumberLiteralType } from 'typescript';
import { Check } from './check';
import { PosTimeRangeDto } from './DTO/pos-time-range.dto';
import { OAuthIntegration } from './oauth-integration';
import { OOLink } from './oo-link';
import { OOMenu } from './oo-menu';
import { OOOrderActiveTime } from './oo-order-active-time';
import { OOOrderType } from './oo-order-type';
import { OOStyles } from './oo-styles';
import { OOTags } from './oo-tags.model';

export class OOVenue {
	venueKey: number;
	name: string;
	phone: string;
	email: string;
	city: string;
	state: string;
	zip: string;
	address1: string;
	address2: string;
	latitude: number;
	longitude: number;
	taxRate: number;
	adminPassword: string;
	ccProcessor: number;
	ccProcessorApiKey: string;
	ccProcessorApiSecret: string;
	ccProcessorMerchantId: string;
	giftProcessor: number;
	giftApiKey: string;
	giftApiSecret: string;
	revenueCenter: string;
	orderActive: boolean;
	ooOrderTypes: OOOrderType[];
	ooOrderActiveTimes: OOOrderActiveTime[];
	timeRanges: any;
	disclaimer: string;
	loadingMessage: string;
	receiptCustomText: string;
	posStatus: number;
	displaySpecialInstructions: boolean;
	displayWhoThisFor: boolean;
	displayPromo: boolean;
	styles: OOStyles;
	orderLeadTime: number;
	linkedVenueKey: number;
	smsMessage: string;
	futureOrderMode: number;
	futureOrderThreshold: number;
	ooMenus: OOMenu[];
	uberStoreId?: string;
	uberOOMenuKey: string;
	uberPriceNumber: number;
	uberPriceModNumber: number;
	doordashPriceNumber: number;
	doordashPriceModNumber: number;
	doordashMenuPreviewUrl: string;
	oAuthIntegrations: OAuthIntegration[];
	orderQueueMode: number;
	orderQueueDailyTime: string;
	orderTypeSelectionText: string;
	orderTimeSelectionText: string;
	timezone: string;
	dealerKey: string;
	ooLinks: OOLink[];
	ccCardSecurityRule: number;
	loyaltyProcessor: NumberLiteralType;
	loyaltyApiKey: string;
	loyaltyApiSecret: string;
	doordashMenuId: string;
	doordashOOMenuId: string;
	outsideOfOrderTimeWindowMessage: string;
	displayUnavailableTimedCanvas: boolean;
	displayUnavailableTimedItem: boolean;
	displayOutOfStockItems: boolean;
	displayOutOfStockItemStatus: boolean;
	displayOutOfStockModifiers: boolean;
	displayOutOfStockModifierStatus: boolean;
	displayCountdownItemStatus: boolean;
	displayCountdownModifierStatus: boolean;
	limitedAvailabilityTag: string;
	mobilePayEnabled: boolean;
	mobilePaySurvey: boolean;
	mobilePayCCSurcharge: string;
	mobilePayAllowPreviousCard: boolean;
	mobilePayTip1: number;
	mobilePayTip2: number;
	mobilePayTip3: number;
	mobilePayTipCustom: boolean;
	mobilePayAdminEmailOnPayment: boolean;
	mobilePayAdminEmailOnSurvey: boolean;
	mobilePayMenuItemKey: number;
	mobilePaySmsMessage: string;
	yelpSurvey: boolean;
	allowFutureOrdersOutsideOOAvailableTime: boolean;
	eGiftEnabled: boolean;
	subscriptionsEnabled: boolean;
	posTimeRanges?: PosTimeRangeDto[];

	orderTotalEmailThreshold: number;
	orderTotalSmsThreshold: number;
	orderSmsNotificationNumber: string[];

	OOTags: OOTags[];

	orders: { [key: string]: number };
	checks: Check[];

	public constructor(init?: Partial<OOVenue>) {
		Object.assign(this, init);
	}
}
